<template>
    <auth-layout>
        <header-page title="Edit Video" />
        <loading-block v-if="loading" />
        <div class="write-form-wrap mt-5" v-else>
            <div class="input-container mb-4">
                <label for="kategori">Kategori</label>
                <select class="form-control" v-bind:class="errors.hasOwnProperty('kategori') ? 'is-invalid' : ''" id="kategori" v-model="form.kategori">
                    <option value="">Pilih kategori</option>
                    <option v-for="item in categories" :value="item.value" v-bind:key="item.id">{{ item.name }}</option>
                </select>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('kategori')">
                    {{ errors['kategori'][0] }}
                </div>
            </div>
            <div class="input-container mb-4">
                <div class="input-wrap title">
                    <clean-input v-model="form.judul" :has-error="errors.hasOwnProperty('judul')" placeholder="Tulis judul artikel disini"/>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('judul')">
                        {{ errors['judul'][0] }}
                    </div>
                    <div class="remaining-text" v-else>
                        {{ 75 - form.judul.length }}/75 Remaining
                    </div>
                </div>
            </div>
            <div class="input-container mb-4">
                <div class="input-wrap desc">
                    <clean-input v-model="form.deskripsi" :has-error="errors.hasOwnProperty('deskripsi')" placeholder="Tulis summary artikel disini"/>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('deskripsi')">
                        {{ errors['deskripsi'][0] }}
                    </div>
                    <div class="remaining-text" v-else>
                        {{ 175 - form.deskripsi.length }}/175 Remaining
                    </div>
                </div>
            </div>
            <div class="input-container mb-4">
                <div class="d-flex">
                    <label for="tag">Tag</label>
                    <tooltip description="Pisahkan dengan tekan enter pada keyboard dan tanpa tanda #"/>
                </div>
                <!-- <input-tag v-model="form.tag" id="tag" v-bind:class="errors.hasOwnProperty('tag') ? 'is-invalid' : ''"></input-tag> -->

                 <div class="vue-input-tag-wrapper">
                 <input type="text" v-model="tags" id="tag" @input="Checktag($event)" v-bind:class="errors.hasOwnProperty('tag') ? 'is-invalid' : ''">
                
                <div class="ma-top"> 
                <span class="input-tag " v-for="itag in form.tag" :key="itag">
                     <span>{{ itag }}</span>
                </span>
                </div>  
                </div>

                <div class="remaining-text">
                   Pisahkan dengan koma dan tanpa tanda #
                </div>
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('tag')">
                    {{ errors['tag'][0] }}
                </div>
            </div>

             <div class="mb-4" >
                <div class="d-flex">
                    <label>Video</label>
                </div>
<!--                 <button type="button" v-if="BtnRecord"  class="btn btn-danger" @click="RecordVideo">Merekam Video</button>-->
                 <button type="button" v-if="BtnUpload" class="btn btn-danger" @click="UploadVideo">Unggah Video</button>
            </div>

            <div class="mb-4" v-if="recordVideo">
                <div class="image-container pointer" v-if="isEmpty(videoSrc)">
                   <record-media @record="recordData" ></record-media>
                </div>
                <div v-else>
                     <video class="video-container" controls>
                        <source :src="videoSrc" >
                    </video>
                </div>
            </div>

             <div class="mb-4" v-if="uploadFile">
                <div class="image-container pointer"  v-bind:class="errors.hasOwnProperty('video') ? 'is-invalid' : ''"  >
                    <div class="image-wrap"  @click="chooseFiles()" v-if="isEmpty(form.video)">
                        <div class="select-image" v-show="UploadBtn">
                            <i class="bi bi-camera-video"></i>
                            <div class="ml-2">Unggah Video</div>
                        </div>

                        <div class="progress loading-submit" v-show="InptLoading">
                            <div class="progress-bar progress-bar-striped" :class="bgprogress" v-bind:style="sProgress" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                                <span class="pa-count"> {{persen}} </span>

                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <video class="video-container" controls>
                            <source :src="videoSrc" >
                        </video>
                        <div class=" mt-1 mb-2 text-center">
                            <button class="btn btn-primary" @click="chooseFiles()">
                                Change Video
                            </button>
                        </div>
                    </div>
                    <div class="invalid-feedback alert-size" v-if="errors.hasOwnProperty('video')">
                        {{ errors['video'][0] }}
                    </div>
                </div>
            </div>

            <div class="input-container mb-4">
                <div class="remaining-text">
                    Format video hanya mp4,mkv,webm,mov,mpg,mpeg,wmv,ogg
                </div>
            </div>

            <div class="mb-4">
                 <div class="d-flex">
                    <label>Cover Video</label>
                </div>
                <div class="image-container pointer" v-bind:class="errors.hasOwnProperty('media') ? 'is-invalid' : ''" @click="openMedia({location: 'base', section: 0})">
                    <div class="image-wrap" v-if="isEmpty(form.media)">
                        <div class="select-image" >
                            <i class="bi bi-image"></i>
                            <div class="ml-2">Sisipkan Gambar</div>
                        </div>



                    </div>
                    <div v-else>
                        <img alt="" :src="form.media.fullpath">
                        <button class="change-image btn btn-primary" @click="openMedia({location: 'base', section: 0})"><i class="bi bi-arrow-repeat"></i></button>
                    </div>
                    <div class="invalid-feedback" v-if="errors.hasOwnProperty('media')">
                        {{ errors['media'][0] }}
                    </div>
                </div>
                <div class="text-center" v-if="!isEmpty(form.media)">{{ form.media.judul }}</div>
            </div>
            <div class="mt-2 mb-4">
                <div class="d-flex">
                    <label>Keterangan Video</label>
                </div>
                <editor
                    v-bind:class="errors.hasOwnProperty('konten') ? 'is-invalid' : ''"
                    v-model="form.konten"
                    id="konten"
                    api-key="o3j7racbw30f4lyqsm8zx2i4ka07u4q8ud3joeh6g7hxp1t4"
                    :init="{
                        paste_as_text: true,
                        height: 250,
                        menubar: false,
                        branding: false,
                        statusbar: false,
                        plugins: [
                           'advlist autolink lists link image charmap print preview anchor',
                           'searchreplace visualblocks code fullscreen',
                           'insertdatetime media table paste code help wordcount'
                        ],
                        toolbar:
                           'undo redo | bold italic underline | bullist numlist | \
                           alignleft aligncenter alignright alignjustify',
                        contextmenu: false,
                    }"
                />
                <div class="invalid-feedback" v-if="errors.hasOwnProperty('konten')">
                    {{ errors['konten'][0] }}
                </div>
            </div>
           <!--  <div class="row mb-5">
                <div class="col-12 text-right">
                    <button class="btn btn-primary" @click="addSection"><i class="bi bi-plus-lg"></i> Tambah Section</button>
                </div>
            </div> -->
            <div>
                <div v-for="(item, index) in sections" v-bind:key="item.id" class="section-container mb-5">
                    <div class="button-close">
                        <div class="btn-move-section">
                            <button class="btn btn-primary" @click="upSection(index)" v-if="sections.length > 1 && index > 0"><i class="bi bi-arrow-up-circle"></i></button>
                            <button class="btn btn-primary" @click="downSection(index)" v-if="sections.length - index > 1"><i class="bi bi-arrow-down-circle"></i></button>
                            <button class="btn btn-primary" @click="removeSection(index)"><i class="bi bi-dash-circle"></i></button>
                        </div>
                    </div>
                    <div class="input-container mb-4">
                        <div class="input-wrap sub">
                            <clean-input v-model="sections[index].title" :has-error="errors.hasOwnProperty(`sections.${index}.title`)" :placeholder="'Tulis Sub Judul Ke-'+ (index+1) +' Di Sini..'"/>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.title`)">
                                {{ errors[`sections.${index}.title`][0] }}
                            </div>
                            <div class="remaining-text" v-else>
                                {{ 75 - sections[index].title.length }}/75 Remaining
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="image-container pointer" v-bind:class="errors.hasOwnProperty(`sections.${index}.media`) ? 'is-invalid' : ''" @click="openMedia({location: 'section', section: index})">
                            <div class="image-wrap" v-if="isEmpty(sections[index].media)" >
                                <div class="select-image">
                                    <i class="bi bi-image"></i>
                                    <div class="ml-2">Sisipkan Gambar</div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="sections[index].type === 'image'" v-bind:class="errors.hasOwnProperty(`sections.${index}.media.image`) ? 'is-invalid' : ''">
                                    <img :alt="sections[index].media.title" :src="sections[index].media.image">
                                    <button class="change-image btn btn-primary" @click="openMedia({location: 'section', section: index})"><i class="bi bi-arrow-repeat"></i></button>
                                    <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.media.image`)">
                                        {{ errors[`sections.${index}.media.image`][0] }}
                                    </div>
                                </div>
                            </div>
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.media`)">
                                {{ errors[`sections.${index}.media`][0] }}
                            </div>
                        </div>
                        <div v-if="sections[index].type === 'image'">
                            <div class="text-center">{{ sections[index].media.title }}</div>
                        </div>
                    </div>
                    <div class="mb-4" v-if="!sections[index].loading">
                        <div class="show-description pointer" v-if="sections[index].descShow === false" @click="sections[index].descShow = !sections[index].descShow">
                            <i class="bi bi-plus-square"></i><div class="ml-2">Tulis deskripsi sub judul ke-{{index+1}}</div>
                        </div>
                        <div class="wrap-text-editor" v-else>
<!--                            <span class="close-button-editor" @click="sections[index].descShow = !sections[index].descShow"><i class="bi bi-arrows-angle-contract"></i></span>-->
                            <editor
                                v-bind:class="errors.hasOwnProperty('description') ? 'is-invalid' : ''"
                                v-model="sections[index].description"
                                api-key="o3j7racbw30f4lyqsm8zx2i4ka07u4q8ud3joeh6g7hxp1t4"
                                :init="{
                                    paste_as_text: true,
                                    height: 150,
                                    menubar: false,
                                    plugins: [
                                       'advlist autolink lists link image charmap print preview anchor',
                                       'searchreplace visualblocks code fullscreen',
                                       'insertdatetime media table paste code help wordcount'
                                    ],
                                    toolbar:
                                       'undo redo | bold italic underline | bullist numlist | \
                                       alignleft aligncenter alignright alignjustify',
                                    contextmenu: false,
                                }"
                            />
                            <div class="invalid-feedback" v-if="errors.hasOwnProperty(`sections.${index}.description`)">
                                {{ errors[`sections.${index}.description`][0] }}
                            </div>
                        </div>
                    </div>
                    <div class="mb-4 text-center" v-else>
                        <pulse-loader color="#EC550E"></pulse-loader>
                    </div>
                </div>
            </div>
            <input id="fileUploadVideo" type="file" @change="setVideo" accept="video/mp4" hidden>
            <div class="recaptcha-wrap" v-bind:class="errors.hasOwnProperty('recaptcha') ? 'error' : ''">
                <vue-recaptcha ref="recaptcha" sitekey="6LewCUwcAAAAAI5TXwwxnMcqc8_c2SANSbkZmNO1" :loadRecaptchaScript=true @verify="handleRecaptcha"></vue-recaptcha>
                <span>Wajib diisi</span>
            </div>
            <div class="button-save">
                <button class="btn btn-primary main-button pill-button submit" data-toggle="tooltip" title="Submit!" @click="previewVideo()" :disabled="InptLoading"><i class="bi bi-cursor"></i> Submit</button>
                <button class="btn btn-primary main-button pill-button" data-toggle="tooltip" title="Save Draft!" @click="handleSubmit(true)"><i class="bi bi-archive"></i></button>
            </div>
        </div>
        <upload-media @media="handleMedia"/>
        <preview-video :data="form" :sections="sections" @submit="handleSubmit" :loading="loading"/>
    </auth-layout>
</template>

<style scoped>
.write-form-wrap {
    padding: 2%;
    background-color: #fff;
    border-radius: 5px;
}
/*FORM*/
.image-container {
    border: 2px dashed #eee;
    position: relative;
}
.image-container img {
    width: 100%;
    height: auto;
}
.change-image {
    position: absolute;
    right: 15px;
    top: 15px;
    border-radius: 50%;
    padding: 4px 10px;
}
.change-image i {
    font-size: 20px;
    width: 20px;
    height: 20px;
}
.image-wrap {
    display: flex;
    justify-content: center;
    padding: 100px;
}
.select-image {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #969696;
}
.section-container {
    position: relative;
}
.button-close {
    position: absolute;
    right: 0;
    top: 40px;
}
.input-container .remaining-text {
    color: #6c757d;
    font-size: 12px;
}
.input-wrap.title .clean-input {
    font-size: 30px;
    font-weight: bold;
    width: 100%;
    height:100%;
    border-color: transparent;
}
.input-wrap.sub .clean-input {
    font-size: 25px;
    font-weight: bold;
}
.input-wrap .clean-input {
    display: flow-root;
    width: auto;
    border: none;
    font-weight: 300;
    font-size: 20px;
}
.input-wrap .clean-input:focus-visible {
    outline: transparent;
}
.input-container select {
    border-bottom: 1px solid #eee;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: unset;
    padding: 0;
    font-size: 16px;
}
.show-description {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    border: 2px solid #eee;
}
.was-validated .form-control:invalid, .form-control.is-invalid {
    background-position: right calc(0.4em + 1.1875rem) center;
    border-bottom: 1px solid #e3342f;
}
.wrap-text-editor {
    position: relative;
}
.close-button-editor {
    position: absolute;
    top: 5px;
    right: 10px;
    z-index: 9999;
    font-size: 20px;
    color: #ec550e;
    cursor: pointer;
}
.button-save {
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    right: 0;
    top: 20%;
    background: #fff;
    border-radius: 10px 0 0 10px;
    box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
    z-index: 99;
}
.button-save button {
    margin: 10px;
    font-size: 22px;
    width: 40px;
    height: 40px;
    padding: 0;
    background: #fff;
    color: #ec550e;
}
.button-save button.submit {
    width: 110px;
    font-size: 15px;
    background-color: #ec550e;
    color: #fff;
}
.btn-move-section button {
    font-size: 20px;
    padding: 0;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    line-height: unset;
    text-align: center;
}
.btn-move-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
}
.input-container .vue-input-tag-wrapper {
    border-bottom: 1px solid #eee;
    border-top: none;
    border-right: none;
    border-left: none;
    border-radius: unset;
    padding-left: 0 !important;
}
.input-container .vue-input-tag-wrapper.is-invalid {
    border-bottom: 1px solid #e3342f;
}
.image-container.is-invalid {
    border: 2px dashed #e3342f;
}
.image-container.is-invalid .invalid-feedback {
    display: block;
    position: absolute;
}

.video-container{
    float: left;
    width: 100%;
}
.alert-size{
  bottom: 0px;
  left: 5px;
}


.loading-submit{
    width: 100%;
}
.progress-bar{
        width: 0%;
}
.progress {
    height: 30px !important;
     margin-bottom: 0px !important;
    overflow: hidden;
    background-color: #f5f5f5;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 2px rgb(0 0 0 / 10%);
    box-shadow: inset 0 1px 2px rgb(0 0 0 / 10%);
}
.pa-count{
       position: relative;
    top: 6px;
}
#tag,#tag:focus {
        border: none!important;
    width: 100%!important;
}
.ma-top{
    float: left;
    margin: 5px 0px 0px;
}
</style>
<style>
.tox-tinymce {
    border-radius: 5px !important
}
.tox-control-wrap {
    display: none;
}
</style>
<script>
import Editor from '@tinymce/tinymce-vue'
import axios from "axios";
import _ from 'lodash';
import $ from 'jquery'
import PreviewVideo from "../../components/PreviewVideo.vue"
import UploadMedia from "../../components/UploadMedia";
import CleanInput from "../../components/CleanInput";
import Tooltip from "../../components/Tooltip";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import {DataURIToBlob} from "../../../mobile/UploadHandler";

import Record from "./Record.vue"

export default {
    data() {
        return {
            loading: true,
            InptLoading:false,
            UploadBtn:true,
            bgprogress:'',
            sProgress:{},
            persen: 0,
            uploadForm: false,
            BtnRecord:true,
            BtnUpload:true,
            recordVideo:true,
            uploadFile:false,
            categories: [],
            videoSrc:'',
            tags:'',
            form: {
                _method: 'PATCH',
                judul: '',
                deskripsi: '',
                konten: '',
                kategori: '',
                tag: [],
                media: {},
                video: '',
                recaptcha: ''
            },
            sections: [],
            descMedia: false,
            location: {
                location: '',
                section: 0
            },
            errors: [],
            isLoading:false,
        }
    },
    components: {
        'editor': Editor,
        'preview-video': PreviewVideo,
        'upload-media': UploadMedia,
        'clean-input': CleanInput,
        'record-media': Record,
        Tooltip,
        PulseLoader
    },
    async mounted() {
        $('[data-toggle="tooltip"]').tooltip();
        await this.getCategory();
        await this.getData();
        this.loading = false;
        this.isLoading = true;
    },
    methods: {

        Checktag($event){

            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                 this.form.tag =  $event.target._value.split(',');
            }, 800);
           
           
   
        },
        async getData() {
            const token = this.$cookies.get('token');
            await axios.get(`/api/video/${this.$route.params.id}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.form.judul = response.data.judul
                    this.form.deskripsi = response.data.deskripsi
                    this.form.konten = response.data.konten
                    this.form.kategori = response.data.kategori === null ? '' : response.data.kategori
                    this.tags = response.data.tag.join(", ")
                    this.form.tag = response.data.tag
                    this.form.media = response.data.file[0]
                    this.form.video = response.data.video[0].video_url
                    this.videoSrc = response.data.video[0].video_url
                    this.sections = response.data.sections;

                     setTimeout(() => {
                       this.isLoading = false;
                    }, 1500);
                     
                })
                .catch((error) => {

                });
        },
        async getCategory () {
            const token = this.$cookies.get('token');
            await axios.get('/api/video/category', { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.categories = response.data
                })
                .catch((error) => {

                });
        },
        handleSubmit(draft = false) {
            const token = this.$cookies.get('token');

            let formData = new FormData();
            formData.append('video',  this.form.video);
            formData.append('judul', this.form.judul);
            formData.append('deskripsi', this.form.deskripsi);
            formData.append('konten', this.form.konten);
            formData.append('kategori', this.form.kategori);
            formData.append('tag', this.form.tag);
            formData.append('cover', this.form.media.photo);
            formData.append('cover_fullpath', this.form.media.fullpath);
            formData.append('cover_title', this.form.media.judul);
            formData.append('cover_caption', this.form.media.captionphoto);
            formData.append('recaptcha', this.form.recaptcha);
            formData.append('sections', this.sections);
            formData.append('draft', Boolean(draft) );
            formData.append("_method", "put");

            this.errors = [];
            this.loading = true;
            axios.post(`/api/video/${this.$route.params.id}`, formData, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    // Handle redirect
                    if(Boolean(draft)) {
                        this.$router.push({name: 'video-draft'});
                    } else {
                        this.$router.push({name: 'video-pending'});
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    $('#previewArticle').modal('hide');
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                        if(error.response.status === 422) {
                            window.scrollTo(0,0);
                            this.errors = error.response.data.errors
                            setTimeout(()=>{
                                this.errors = [];
                            },15000);
                        }
                    }
                    this.loading = false;
                    // Reset recaptcha for load new
                    this.$refs.recaptcha.reset();
                });
        },
        handleRecaptcha(response) {
            if(response) {
                this.form.recaptcha = response
            }
        },
        handleMedia(e) {
            if(!this.isEmpty(e)) {
                if(this.location.location === 'base') {
                    this.form.media = {
                        photo: e.file[0].oriphoto,
                        fullpath: e.file[0].orifullpath,
                        cropphoto: null,
                        fullpathcrop: null,
                        captionphoto: e.captionphoto,
                        judul: e.judul
                    };
                } else {
                    this.sections[this.location.section].media = {
                        image: e.file[0].orifullpath,
                        title: e.captionphoto
                    };
                }
                this.location = {
                    location: '',
                    section: 0
                };
            }
        },
        handleRemoveMedia() {
            if(this.form.media) {
                this.form.media = {};
            }
        },
        openMedia(location) {
            this.location = location;
            $('#mediaGallery').modal({
                backdrop: 'static',
                keyboard: false
            });
        },
        previewVideo() {
            $('#previewArticle').modal({
                backdrop: 'static',
                keyboard: false
            });
        },
        RecordVideo(){
          this.recordVideo = true;
          this.uploadFile = false;
          this.BtnRecord = false;
          this.BtnUpload = true;
          this.videoSrc ='';
        },
        UploadVideo(){
          this.recordVideo = false;
          this.uploadFile = true;
          this.BtnRecord = true;
          this.BtnUpload = false;
          this.videoSrc = '';
          this.form.video = '';
        },
        blobToBase64(blob) {
          return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        },

        async recordData(data){
          this.videoSrc  = await this.blobToBase64(data);
        },
        addSection() {
            var lastId;
            if(this.sections.length > 0) {
                let orderByHigh = _.orderBy(this.sections, ['id'], ['asc']);
                let last = _.last(orderByHigh);
                lastId = last.id;
            } else {
                lastId = 0;
            }
            this.sections.push({
                id: lastId + 1,
                title: '',
                type: 'image',
                media: {},
                description: '',
                descShow: true,
                loading: false
            });
        },
        chooseFiles() {
            this.videoSrc = '';
            this.form.video = '';
            document.getElementById("fileUploadVideo").click();
        },

        async setVideo(e) {
            const token = this.$cookies.get('token');
            const file = e.target.files[0];
            // Upload video
            let formData = new FormData();
            formData.append('video', file);
            this.uploading = true;
            const config = {
                headers: {"Authorization" : `Bearer ${token}`, 'Content-Type': 'multipart/form-data'},
                onUploadProgress: progressEvent => this.proggresbar(progressEvent)
            }
            await axios.post(`${process.env.MIX_UPLOAD_URL || ''}/api/video/upload`, formData, config)
                .then((response) => {
                    this.videoSrc = response.data.url;
                    this.form.video = response.data.url;
                    this.InptLoading = false;
                })
                .catch((error) => {
                    this.InptLoading = false;
                    console.log(error.response.data);
                });
            //
        },
        proggresbar(progressEvent){
            var percentage = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100,
            );

            this.InptLoading = true;
            this.UploadBtn = false;
            this.bgprogress = 'bg-danger';
            var size = percentage;
            size = size + 1;
            this.sProgress = { width: size + '%'};
            this.persen = size+'%';
            if (size >= 50 && size < 100){
                this.bgprogress = 'bg-warning';
            } else if (size>= 100){
                this.bgprogress = 'bg-success';
                this.persen = 'Done';
            }
        },

        removeSection(index) {
            this.sections.splice(index, 1);
        },
        upSection(index) {
            this.sections[index].loading = true
            this.sections[index-1].loading = true

            let previousSbiling = this.sections[index - 1]
            this.sections.splice(index - 1, 1)
            this.sections.splice(index, 0, previousSbiling)

            var self = this;
            setTimeout(() => {
                self.sections[index].loading = false
                self.sections[index-1].loading = false
            }, 500);
        },
        downSection(index) {
            this.sections[index].loading = true
            this.sections[index+1].loading = true

            let target = this.sections[index]
            this.sections.splice(index, 1)
            this.sections.splice(index + 1, 0, target)

            var self = this;
            setTimeout(() => {
                self.sections[index].loading = false
                self.sections[index+1].loading = false
            }, 500);
        },
        isEmpty (value) {
            return _.isEmpty(value);
        }
    }
}
</script>

